var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Vue } from 'vue-property-decorator';
import * as yup from 'yup';
var LifeValidationMixin = /** @class */ (function (_super) {
    __extends(LifeValidationMixin, _super);
    function LifeValidationMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LifeValidationMixin.prototype.isValidBirthDateFormat = function (value) {
        return /^\d{2}-\d{2}-\d{4}$/.test(value);
    };
    LifeValidationMixin.prototype.parseBirthDate = function (value) {
        if (!this.isValidBirthDateFormat(value))
            return null;
        var _a = value.split('-').map(Number), day = _a[0], month = _a[1], year = _a[2];
        var today = new Date();
        var currentYear = today.getFullYear();
        var minYear = currentYear - 75;
        if (day < 1 || day > 31)
            return null;
        if (month < 1 || month > 12)
            return null;
        if (year < minYear || year > currentYear)
            return null;
        var birthDate = new Date(year, month - 1, day);
        var isExactDate = birthDate.getFullYear() === year
            && birthDate.getMonth() === month - 1
            && birthDate.getDate() === day;
        return isExactDate ? birthDate : null;
    };
    LifeValidationMixin.prototype.isBirthDateWithinAllowedAge = function (value) {
        var birthDate = this.parseBirthDate(value);
        if (!birthDate)
            return false;
        var today = new Date();
        var todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        var seventyFiveYearsAgo = new Date(today.getFullYear() - 75, today.getMonth(), today.getDate());
        return birthDate <= todayStart && birthDate >= seventyFiveYearsAgo;
    };
    Object.defineProperty(LifeValidationMixin.prototype, "step1ValidationSchema", {
        get: function () {
            var _this = this;
            var _a;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step1) || {};
            return yup.object().shape({
                firstName: yup
                    .string()
                    .required(t.first_name_required || 'Ad tələb olunur')
                    .matches(/^[A-Za-zƏəİıÖöÜüĞğŞşÇç\s]+$/, t.first_name_invalid || 'Ad yalnız hərflərdən ibarət olmalıdır')
                    .max(30, t.first_name_max || 'Ad maksimum 30 simvol ola bilər'),
                lastName: yup
                    .string()
                    .required(t.last_name_required || 'Soyad tələb olunur')
                    .matches(/^[A-Za-zƏəİıÖöÜüĞğŞşÇç\s]+$/, t.last_name_invalid || 'Soyad yalnız hərflərdən ibarət olmalıdır')
                    .max(30, t.last_name_max || 'Soyad maksimum 30 simvol ola bilər'),
                fatherName: yup
                    .string()
                    .required(t.father_name_required || 'Ata adı tələb olunur')
                    .matches(/^[A-Za-zƏəİıÖöÜüĞğŞşÇç\s]+$/, t.father_name_invalid || 'Ata adı yalnız hərflərdən ibarət olmalıdır')
                    .max(30, t.father_name_max || 'Ata adı maksimum 30 simvol ola bilər'),
                address: yup
                    .string()
                    .required(t.address_required || 'Ünvan tələb olunur')
                    .max(200, t.address_max || 'Ünvan maksimum 200 simvol ola bilər'),
                birthDate: yup
                    .string()
                    .required(t.birth_date_required || 'Doğum tarixi tələb olunur')
                    .matches(/^\d{2}-\d{2}-\d{4}$/, t.birth_date_invalid || 'Doğum tarixi düzgün deyil (DD-MM-YYYY)')
                    .test('is-valid-birth-date', t.birth_date_invalid || 'Doğum tarixi düzgün deyil (DD-MM-YYYY)', function (value) {
                    if (!value || !_this.isValidBirthDateFormat(value))
                        return false;
                    return _this.parseBirthDate(value) !== null;
                })
                    .test('is-valid-age', t.birth_date_age_invalid || 'Yaş maksimum 75 olmalıdır', function (value) {
                    if (!value || !_this.isValidBirthDateFormat(value))
                        return true;
                    if (_this.parseBirthDate(value) === null)
                        return true;
                    return _this.isBirthDateWithinAllowedAge(value);
                }),
                phone: yup
                    .string()
                    .required(t.phone_required || 'Telefon nömrəsi tələb olunur')
                    .test('phone-format', t.phone_invalid || 'Telefon nömrəsi düzgün formatda deyil', function (value) {
                    if (!value)
                        return true;
                    var digits = value.replace(/\D/g, '');
                    if (digits.length !== 12) {
                        return this.createError({
                            message: t.phone_invalid || 'Telefon nömrəsi tam daxil edilməlidir'
                        });
                    }
                    var operatorCode = digits.substring(3, 5);
                    var allowedCodes = ['10', '50', '51', '55', '70', '77', '99'];
                    if (!allowedCodes.includes(operatorCode)) {
                        return this.createError({
                            message: t.phone_operator_invalid || 'Operator kodu düzgün deyil (10, 50, 51, 55, 70, 77, 99)'
                        });
                    }
                    return true;
                }),
                passport: yup
                    .string()
                    .required(t.passport_required || 'Şəxsiyyət vəsiqəsi tələb olunur')
                    .test('passport-length', t.passport_invalid || 'Şəxsiyyət vəsiqəsi düzgün formatda deyil', function (value) {
                    var _a;
                    if (!value)
                        return true;
                    var docType = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.docType;
                    var expectedLength = docType === 'AZE' ? 8 : 7;
                    var digitsOnly = /^\d+$/.test(value);
                    if (!digitsOnly) {
                        return this.createError({
                            message: t.passport_invalid || 'Şəxsiyyət vəsiqəsi yalnız rəqəmlərdən ibarət olmalıdır'
                        });
                    }
                    if (value.length !== expectedLength) {
                        var message = docType === 'AZE'
                            ? (t.passport_invalid_aze || 'Şəxsiyyət vəsiqəsi 8 rəqəmdən ibarət olmalıdır')
                            : (t.passport_invalid_other || 'Sənəd nömrəsi 7 rəqəmdən ibarət olmalıdır');
                        return this.createError({ message: message });
                    }
                    return true;
                }),
                fin: yup
                    .string()
                    .required(t.fin_required || 'FIN kod tələb olunur')
                    .length(7, t.fin_invalid || 'FIN kod 7 simvoldan ibarət olmalıdır'),
                gender: yup
                    .string()
                    .required(t.gender_required || 'Cins seçilməlidir'),
                docType: yup
                    .string()
                    .required()
            });
        },
        enumerable: false,
        configurable: true
    });
    LifeValidationMixin.prototype.validateStep1 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1, errors_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Validating Step1...', this.stepsData.step1);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.step1ValidationSchema.validate(this.stepsData.step1, { abortEarly: false })];
                    case 2:
                        _a.sent();
                        this.step1Errors = {};
                        console.log('Step1 validation passed');
                        return [2 /*return*/, true];
                    case 3:
                        err_1 = _a.sent();
                        errors_1 = {};
                        if (err_1.inner) {
                            err_1.inner.forEach(function (error) {
                                errors_1[error.path] = error.message;
                            });
                        }
                        this.step1Errors = errors_1;
                        console.log('Step1 validation failed:', errors_1);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LifeValidationMixin.prototype.validateStep2 = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var t;
            return __generator(this, function (_b) {
                console.log('Validating Step2...', this.stepsData.step2);
                t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step2) || {};
                console.log(this.stepsData.step2.agreed);
                if (this.stepsData.step2.agreed != true) {
                    console.log('Step2 validation failed: agreed not checked');
                    this.step2Errors = {
                        agreed: t.agreement_required || 'Davam etmək üçün şərtlərlə razılaşmalısınız'
                    };
                    console.log('Step2 validation failed:', this.step2Errors);
                    return [2 /*return*/, false];
                }
                this.step2Errors = {};
                console.log('Step2 validation passed');
                return [2 /*return*/, true];
            });
        });
    };
    LifeValidationMixin.prototype.validateStep3 = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var t, errors;
            return __generator(this, function (_b) {
                console.log('=== Validating Step3 (company) ===');
                console.log('stepsData.step3:', this.stepsData.step3);
                t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step3) || {};
                errors = {};
                if (!this.stepsData.step3.selectedCompanyId) {
                    errors.company = t.company_required || 'Sığorta şirkəti seçilməlidir';
                }
                if (Object.keys(errors).length > 0) {
                    this.step3Errors = errors;
                    console.log('❌ Step3 validation FAILED:', errors);
                    return [2 /*return*/, false];
                }
                this.step3Errors = {};
                console.log('✅ Step3 validation PASSED');
                return [2 /*return*/, true];
            });
        });
    };
    LifeValidationMixin.prototype.validateStep4 = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var t, errors;
            return __generator(this, function (_b) {
                console.log('=== Validating Step4 (package) ===');
                console.log('stepsData.step4:', this.stepsData.step4);
                t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step4) || {};
                errors = {};
                // Validate start date
                if (!this.stepsData.step4.startDate) {
                    errors.startDate = t.start_date_required || 'Başlama tarixi tələb olunur';
                }
                // Validate coverage amount
                if (!this.stepsData.step4.coverageAmount) {
                    errors.coverageAmount = t.coverage_amount_required || 'Sığorta təminatı seçilməlidir';
                }
                // Validate selected package
                if (!this.stepsData.step4.selectedPackage) {
                    errors.selectedPackage = t.package_required || 'Paket seçilməlidir';
                }
                if (Object.keys(errors).length > 0) {
                    this.step4Errors = errors;
                    console.log('❌ Step4 validation FAILED:', errors);
                    return [2 /*return*/, false];
                }
                this.step4Errors = {};
                console.log('✅ Step4 validation PASSED');
                return [2 /*return*/, true];
            });
        });
    };
    LifeValidationMixin.prototype.validateCurrentStep = function (currentStep) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(currentStep === 1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.validateStep1()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        if (!(currentStep === 2)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.validateStep2()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        if (!(currentStep === 3)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.validateStep3()];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6:
                        if (!(currentStep === 4)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.validateStep4()];
                    case 7: return [2 /*return*/, _a.sent()];
                    case 8: return [2 /*return*/, true];
                }
            });
        });
    };
    LifeValidationMixin = __decorate([
        Component
    ], LifeValidationMixin);
    return LifeValidationMixin;
}(Vue));
export default LifeValidationMixin;
